import PVChart from '../../common/pv-chart'

$(() => {
  if (!$('#owner-items_show').length) {
    return
  }

  new PVChart($('#pv'))
})

// ジョブコミ独自: 求人一覧の「掲載停止」(アルムニアへの掲載停止リクエスト)
$(() => {
  if (!$('#owner-items_index').length) {
    return
  }

  $(document).on('click', '.js-item-alumnia-stop', (e) => {
    e.preventDefault()
    const link = $(e.currentTarget)

    if (!window.confirm('この操作は取り消せません。掲載を停止してよろしいですか？')) {
      return
    }

    $.ajax({
      url: link.data('url'),
      type: 'PATCH',
      dataType: 'json',
    }).done((data) => {
      if (data.success) {
        window.alert('アルムニア側で正常に掲載停止処理が行われました')
        window.location.reload()
      } else {
        window.alert(data.message || 'アルムニア掲載API実行中にエラーが発生しました')
      }
    }).fail((jqXHR) => {
      const message = jqXHR.responseJSON && jqXHR.responseJSON.message
      window.alert(message || 'アルムニア掲載API実行中にエラーが発生しました')
    })
  })
})